import React, { useEffect, useState, useMemo } from "react";
import {
  Container,
  Typography,
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import FactoryIcon from '@mui/icons-material/Factory';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PersonIcon from '@mui/icons-material/Person';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from "react-router-dom";
import { UrlApiEnvasado} from "../../../services/apirest"
import Navbar from "../../Navbar";

function DatosSucursalAogas() {
  let navigate = useNavigate();
  const [tabla, setTabla] = useState(true);
  const [sucursales, setSucursales] = useState()

  const obtenerSucursales = () => {
    fetch(UrlApiEnvasado + "api/envasado/sucursales/aogas")
      .then((data) => data.json())
      .then((data) => setSucursales(data));
  };
  useEffect(() => {
    obtenerSucursales()
  }, [])
  

    const columns = useMemo(
      () => [
        {
          accessorKey: "id", //access nested data with dot notation
          header: "ID",
          maxSize: 20,
        },
        {
          accessorKey: "name", //access nested data with dot notation
          header: "Sucursal",
          size: 115,
        },
      ],
      []
    );
    const customLocalization = {
      ...MRT_Localization_ES,
      expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
      expand: "Ex", // Cambia 'Expandir' a 'Ex'
    };

    const muiSearchTextFieldProps = {
        placeholder: "Buscar..",
        sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
        variant: "outlined",
        color: "primary",
        size: "small",
      };
      
      const tableHeadCellProps = {
        align: "left",
        sx: {
          fontSize: 16,
          color: "white",
          fontWeight: "normal",
          backgroundColor: "#2471A3",
          borderColor: "black",
        },
      };
    
      const initialState = {
        //para inicializar la tabla, y la cantidad de paginas q se ven ej 5
        density: "compact",
        showGlobalFilter: true,
        pagination: { pageIndex: 0, pageSize: 10 },
      };

      
  return (
    <div>
      <Navbar/>
      <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 1 }}>
        {tabla && (
          <Box mt={2} mb={4}>
          <MaterialReactTable
            columns={columns}
            data={sucursales ?? [{}]}
            layoutMode={"grid"}
            initialState={initialState}
            enableColumnActions={false} //deshabilita las acciones POR COLUMN}
            enableGlobalFilterModes={false}
            enableHiding={false}
            enableGrouping={true}
            enablePinning={true}
            enableColumnFilters={false}
            enableFullScreenToggle={false}
            positionActionsColumn={"last"}
            enableExpandAll={false}
            enableEditing
            localization={customLocalization}
            enableToolbarInternalActions={true}
            muiTableHeadCellProps={tableHeadCellProps}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            enableDensityToggle={false}
            // muiTableBodyRowProps={({ row }) => ({
            //   sx: {
            //     backgroundColor: row.original.estado === 272
            //       ? null
            //       : row.original.estado === 273
            //       ? "#ffff88"
            //       : row.original.estado === 274
            //       ? "#acec98"
            //       : null,
            //   },
            // })}
            // muiTableDetailPanelProps={{
            //   sx: {
            //     backgroundColor: 'white', // Fondo blanco para el panel de detalles
            //     width: '100%', 
            //   },
            // }}
            enableColumnResizing={true}
            // renderDetailPanel={({ row }) => <Pedidos_rendicion row={row.original} />}
            muiTableBodyCellProps={({ row }) => ({
              align: "left",
            })}
            renderTopToolbarCustomActions={() => (
              <div style={{alignContent:"center"}}>
                <Typography variant="poster" fontSize={26}>
                  <FactoryIcon sx={{ fontSize: 25 }} />
                    -
                    Sucursales de Aogas
                </Typography>
              </div>
            )}
            renderRowActions={(
              { row } //las acciones del costado editar y ver
            ) => (
              <div>
                <Tooltip arrow placement="left" title="Ver Datos">
                  <IconButton
                    onClick={() => navigate("/detalledatosaogas",{ state: row.original })}
                    color="primary"
                  >
                    <VisibilityIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip arrow placement="top" title="Choferes">
                  <IconButton
                    onClick={() => navigate("/listachoferesaogas",{ state: row.original })}
                    color="secondary"
                  >
                    <PersonIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip arrow placement="right" title="Móviles">
                  <IconButton
                    onClick={() => navigate("/listamovilesaogas",{ state: row.original })}
                    color="default"
                  >
                    <LocalShippingIcon />
                  </IconButton>
                </Tooltip>
              </div>
            )}
          />
          </Box>
        )}
      </Container>
    </div>
  )
}

export default DatosSucursalAogas